module.exports = __webpack_public_path__ + "static/jay.fc690f80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/jay.jpg
// module id = 535
// module chunks = 95715928098905 264598414423048